import { render } from "./XIconSolidBadgeCheck.vue?vue&type=template&id=7a82481b"
import script from "./XIconSolidBadgeCheck.vue?vue&type=script&lang=js"
export * from "./XIconSolidBadgeCheck.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidBadgeCheck.vue"]])

export default __exports__